import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
  useReducer,
} from "react";
import {
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
  MDBContainer,
  MDBCardBody,
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";

import WebGlApp from "webgl";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import TreeViewMenu from "react-simple-tree-menu";
import ResizablePanels from "resizable-panels-react";
import jwt_decode from "jwt-decode";
import Share from "components/Share";
import { setCompanyUsers, setProjects, setProjectfilesTree } from "actions/user";
import { setUser } from "actions/user";
import { setJWT, tokenRef } from "api";
import Loading from "components/ui-components/loading";
import NoMeshModal from "../../components/NoMeshModal";
import ResizableViewer from "components/hoc/resizable-viewer/resizable-viewer";
import addNotification from "helpers/notify";
import { useHttp } from "../../hooks/useHttp";
import { getJsonFile, getCompressedJsonFile } from "api/files/getJsonFile";
import { classifyModelFetchError, modelErrorText, NO_MODEL_FILE } from "./modelFetchError";
import { url, IFC_Url } from "api";
import { Maybe } from "helpers/maybeFunctor";
import { getProjects } from "api/projects/getProjects";
import { useHttpWithCache } from "hooks/useHtthWithCache";
import TreeViewerItem from "components/TreeViewerItem";
import useBranchGeometry from "hooks/useBranchGeometry";
import { generateId } from "helpers/id";
import {
  findRowForRecord,
  recordFromClick,
  generateMeshes,
  generateSubprojectMeshes,
  generateTree,
  generateSubprojectTree,
  generateRawMeshes,
  generateRawTree,
} from "helpers/three";
import { scopeTreeIds } from "helpers/stableNodeId";

import "./TimelineViewer.scss";
import { useLogout } from "hooks/useLogout";

import { ReactComponent as CloseIcon } from "../../assets/images/down-arrow.svg";
import useProjectFiles from "hooks/useProjectFiles";
import CollapsibleTable from "components/CollapsibleTable";
import ClockIcon from "assets/images/clock.png";
// import existingImg from "assets/images/exist-comp.png";
import demoImg from "assets/images/demo-comp.png";

import estimationImg from "assets/images/estimationImg.png";
import pricedImg from "assets/images/pricedImg.png";
import unpricedImg from "assets/images/unpricedImg.png";
import existingImg from "assets/images/existingImg.png";
import demolition from "assets/images/demolition.png";
import projectIcon from "assets/images/projectIcon.png";
import { QuantityContext } from "../../hooks/quantityContext";
import { mainAdminGetCompanies } from "api/users/mainAdminGetCompanies";
import { mainAdminGetCompanyDetails } from "api/users/mainAdminGetCompanyDetails";
import { buildDocumentSets, flattenRecords } from "helpers/documentSets";
import { ensure as ensureSourceFilter } from "webgl/js/loader/streaming/sourceFilterRegistry";
import ViewerEffectsButton from "components/Viewer/ViewerEffectsButton";
import ViewerViewButtons from "components/Viewer/ViewerViewButtons";
import { expandKeysForPath, scrollTargetId, findClickedMesh } from "helpers/treePathKeys";
import { scrollRowToCentre } from "helpers/scrollRowToCentre";
import { reportClientError } from "helpers/clientLog";
import { unstable_batchedUpdates } from "react-dom";
import { treeLocate, treeChildren, openKeysFromLocate, leafKeyFromLocate, leafRowIdFromLocate, serverBranch } from "helpers/modelTreeApi";
import ViewerToolbar from "components/Viewer/ViewerToolbar";
import { hoverPriceLabel } from './hoverPriceLabel';
import { attachBuildingGrid } from "helpers/buildingGridLoad";

let numeral = require("numeral");
let summ = null;

// Classify a pathsmapping entry as a streaming-pipeline file.
//
// See ModelViewer.jsx for the full rationale. Same classifier mirrored
// here because TimelineViewer also iterates timeline.zipInfo.pathsmapping
// to build its legacy JSONs/GLBs lists. Without this, every streaming
// tile sidecar (tiles/tile_X.json.gz) would be treated as a legacy
// project JSON and fetched serially (once per tile, plus 3 sibling
// /undefined fetches each), blocking WebGlApp construction by minutes
// on streaming-enabled timelines.
//
// Mirrors the C# IsStreamingPipelineFile classifier in
// R2FileUploadUtility — keep these two in sync if the exporter ever
// adds a new streaming-pipeline file type.
const isStreamingPipelineEntry = (name) => {
  if (!name) return false;
  const lower = String(name).replace(/^\/+/, "").toLowerCase();
  if (lower === "manifest.json" || lower === "manifest.json.gz") return true;
  if (lower.startsWith("tiles/")) return true;
  if (lower.startsWith("fragments/")) return true;
  if (
    lower.startsWith("library.") &&
    (lower.endsWith(".glb") || lower.endsWith(".glb.gz"))
  ) {
    return true;
  }
  return false;
};

// Named, so the call site says WHY rather than naming a react-dom internal.
const batch = (fn) => unstable_batchedUpdates(fn);

const TimelineViewer = (props) => {
  const { projectId, timelineId, token, line, personal } = props;
  const dispatch = useDispatch();
  const logOut = useLogout();
  const viewerRef = useRef();
  const WebGL = useRef();
  // The viewer goes with the page: its streaming session, render loop,
  // window listeners and GL context (WebGlApp.dispose).
  useEffect(() => () => {
    try { if (WebGL.current && typeof WebGL.current.dispose === "function") WebGL.current.dispose(); } catch (e) { /* best effort */ }
    WebGL.current = null;
  }, []);
  const history = useHistory();
  const resizeRef = useRef();
  const [pending, setPending] = useState([]);
  const [withShare, setWith] = useState([]);
  const [menu, setMenu] = useState("");
  const [point, setPoint] = useState(false);
  const [summary, setSummary] = useState(null);
  const [currencysymb, setCurrencysymb] = useState("");
  const projectsRedux = useSelector((s) => s.user.projects);
  const usersRedux = useSelector((s) => s.user.users);
  const userInfoRedux = useSelector((s) => s.user.userInfo);

  // One-shot drill-in for admin users. Triggered when the user is
  // an admin AND projectsRedux is null (i.e., the lightweight
  // /admin-panel call returned empty company_projects). We fetch
  // the user's own company via /admin-panel/companies/:id and
  // dispatch setProjects + setCompanyUsers. The adminDrillInFiredRef
  // guard ensures the dispatch fires AT MOST ONCE per mount — the
  // first version of this lived inside the useHttpWithCache
  // reduxSetter, which got re-invoked with cached data on every
  // render whose reduxCash shape changed, causing the React #185
  // "Maximum update depth exceeded" loop on cold deep-link opens.
  const adminDrillInFiredRef = useRef(false);
  useEffect(() => {
    if (adminDrillInFiredRef.current) return;
    if (!userInfoRedux?.admin) return;
    const companyId = userInfoRedux?.company;
    if (!companyId) return;
    if (projectsRedux && projectsRedux.length > 0) {
      // Already loaded by some other code path; nothing to do.
      adminDrillInFiredRef.current = true;
      return;
    }
    adminDrillInFiredRef.current = true;
    mainAdminGetCompanyDetails(companyId)
      .then((detail) => {
        if (!detail) return;
        dispatch(setProjects(detail.projects || []));
        dispatch(setCompanyUsers(detail.users || []));
      })
      .catch((err) => {
        // If the drill-in fails, clear the ref so the user can
        // retry by re-mounting (e.g., refresh the page) — but
        // don't loop within the same mount.
        console.log("TimelineViewer admin drill-in failed:", err?.message || err);
      });
  }, [userInfoRedux?.admin, userInfoRedux?.company, projectsRedux, dispatch]);

  const selectedMesh = useRef(null);

  useLayoutEffect(() => {
    function updateSize() {
      // setSize([window.innerWidth, window.innerHeight]);
      const currWindowHeight = window.innerHeight;
      const currWindowWidth = window.innerWidth;
      setWindowWidth(currWindowWidth);

      setSecondScreen(true);
      if (currWindowWidth < 1300) setFirstScreen(false);
      if (currWindowWidth < 900) setThirdScreen(false);
      if (currWindowWidth < 600) setSecondScreen(false);

      if (currWindowWidth >= 1300) setFirstScreen(true);
      if (currWindowWidth >= 900) setThirdScreen(true);
      if (currWindowWidth >= 600) setSecondScreen(true);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Deep-link token resolution. Notifications include a URL like
  // /personal-area/projects/:projectId/timelines/:timelineId/:token —
  // when the user opens it directly (no existing session), this
  // effect decodes the JWT, hydrates Redux user state, and persists
  // the token to localStorage so subsequent API calls authenticate.
  //
  // Guarded against re-firing after the first successful decode so we
  // don't keep re-dispatching setUser on every render (which was
  // contributing to the React #185 "Maximum update depth exceeded"
  // loop on cold-start deep links). The effect dep [token] is a
  // primitive string from the route param so React's bailout already
  // skips identical-string runs, but the user-already-hydrated guard
  // protects against StrictMode double-invocation + any edge where
  // token re-evaluates.
  useEffect(() => {
    try {
      if (!token) return;
      // If we already decoded this token into the same userInfo,
      // skip re-dispatching. Comparing by decoded user _id is cheap
      // and avoids replaying the dispatch on every re-render.
      const decoded = jwt_decode(token);
      if (userInfoRedux && decoded
          && String(userInfoRedux._id) === String(decoded._id || decoded.id)) {
        return;
      }
      localStorage.setItem(tokenRef, token);
      setJWT(token);
      dispatch(setUser(decoded));
    } catch (err) {
      console.log(err);
      addNotification(err.message, "danger");
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  useEffect(() => {
    if (menu) {
      resizeRef.current.state.panelsSize = [100];
    } else {
      resizeRef.current.state.panelsSize = [0];
    }
    setPoint((prev) => !prev);
  }, [menu]);

  // The list row is slim; each timeline's model file lists come with the
  // project itself (hooks/useProjectFiles). A shared link (line) is whole.
  const listProject = Maybe.of(projectsRedux).map((projects) => {
      return projects.filter((project) => project._id == projectId)[0];
    }).value;
  const projectWithFiles = useProjectFiles(line?.line ? null : projectId, listProject);
  const project = line?.line || projectWithFiles;

  const neededTimeline =
    line?.line ||
    Maybe.of(projectWithFiles)
      .map((project) => project.timelines)
      .map((timelines) =>
        timelines.find((timeline) => {
          return timeline._id === timelineId;
        })
      ).value;

  // PRIOR BUG: this effect's dependency array was [summary] — i.e. it
  // set summary based on neededTimeline but re-fired whenever summary
  // itself changed. On a deep-link cold start (notification → URL
  // with token), the chain (token-effect → setUser → projects fetch →
  // neededTimeline materialises) eventually triggered this setter
  // which then set itself in a tight loop, hitting React error #185
  // "Maximum update depth exceeded".
  //
  // The dependency must be [neededTimeline] (the INPUT) not [summary]
  // (the OUTPUT). The setter-equality bailout still avoids redundant
  // re-renders when neededTimeline.summary hasn't changed.
  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && neededTimeline != null) {
      summ = neededTimeline.summary;
      setSummary(summ);
      if (neededTimeline?.currencysymb)
        setCurrencysymb(neededTimeline?.currencysymb || "");
    }
  }, [neededTimeline]);

  useEffect(() => {
    console.log("Project UseEffect*********")
    isMountedRef.current = true;
    if (neededTimeline?.pending_share)
      setPending(neededTimeline?.pending_share || []);
    if (neededTimeline?.summary) setSummary(neededTimeline?.summary || null);
    if (neededTimeline?.currencysymb)
      setCurrencysymb(neededTimeline?.currencysymb || "");
    setWith(neededTimeline?.shared_with || []);
    if (isMountedRef.current && neededTimeline && project && !isGLOpend) {
      setGLOpend(true);
      initializeAPI();
      {
        setMenu("navigate");
      }
    }

    return () => (isMountedRef.current = false);
  }, [neededTimeline, project]);

  // EVERY SOURCE THIS PAGE'S CLICK HANDLER READS, in one box it can reach
  // (owner, 2026-10-20: the model tree must work on every page that uses it).
  //
  // All eight `let`s below and the seven arrays further down live in the
  // component body, so React resets them on EVERY render - and the viewer
  // stores this page's callbacks ONCE (webgl/js/viewer/index.js:509), so
  // findInJsonUsingViewer is the closure from mount. Worse than the other
  // pages: these start as `null`, and the handler calls .find() on them
  // directly, so a click did not miss quietly - it threw
  // "Cannot read properties of null" before reaching any branch.
  //
  // Mirrored where each one is filled, so a click reads what the download
  // produced instead of what this render happens to hold.
  const srcRef = useRef({});
  let meshes = null;
  let treeMeshes = null;

  let unmatchedMeshes = null;
  let treeUnmatchedMeshes = null;

  let existingMeshes = null;
  let treeExistingMeshes = null;

  let demolitionMeshes = null;
  let treeDemolitionMeshes = null;

  const isMountedRef = useRef(null);

  const [meshesArray, setMeshes] = useState(null);
  const [hoverMesh, setHoverMesh] = useState({});
  const [clickedChild, setClickedChild] = useState([]);
  const [clickedUnmatchedChild, setClickedUnmatchedChild] = useState([]);
  //
  const [clickedExistingChild, setClickedExistingChild] = useState([]);
  const [clickedDemolitionChild, setClickedDemolitionChild] = useState([]);
  //
  const [treeData, setTreeData] = useState([]);
  const [treeUnmatchedData, setTreeUnmatchedData] = useState([]);
  //
  const [treeExistingData, setTreeExistingData] = useState([]);
  const [treeDemolitionData, setTreeDemolitionData] = useState([]);
  // 
  const [percentsLoaded, setPercentsLoaded] = useState(0);
  const [allowToResize, setAllowToResize] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  // WHY THE MODEL IS NOT THERE, IN WORDS, ON THE PAGE.
  // `error` above is a boolean that is passed to the viewer and NEVER
  // RENDERED, so a failure here showed the person an empty canvas and no
  // reason. Two different faults reach this page and they are not the same
  // thing, so they do not collapse into one string:
  //   the model file 404s and the body is empty      -> nothing to load
  //   the model file 404s and storage returns an XML -> that XML was being
  //     handed to JSON.parse, which threw "Unexpected token '<'" before the
  //     viewer ever mounted (prod, 2026-09-27: seven of seven timelines).
  const [modelError, setModelError] = useState("");
  const [modal, setModal] = useState(false);
  // WHY nothing can be shown, in the user's words (owner 2026-10-20). Empty
  // keeps the old sentence for any caller not yet converted.
  const [noMeshReason, setNoMeshReason] = useState('');
  // The branch the server returns, when the legacy loops had nothing.
  const [serverTree, setServerTree] = useState(null);
  const [openNodes, setOpenNodes] = useState([]);
  const [unmatchedOpenNodes, setUnmatchedOpenNodes] = useState([]);
  //
  const [existingOpenNodes, setExistingOpenNodes] = useState([]);
  const [demolitionOpenNodes, setDemolitionOpenNodes] = useState([]);
  //
  const [isPopover, setIsPopOver] = useState(false);
  const [popoverCoords, setCoordsForPopover] = useState({
    top: "0px",
    left: "0px",
  });
  const [scrollId, setScrollId] = useState("");
  const [unmatchedMeshesArray, setUnMatchedMeshes] = useState(null);
  //
  const [existingMeshesArray, setExistingMeshes] = useState(null);
  const [demolitionMeshesArray, setDemolitionMeshes] = useState(null);
  //
  const [resize, setResize] = useState(null);
  const [isUnmatchedMeshes, setIsUnmatchedMeshes] = useState(false);
  //
  const [isExistingMeshes, setIsExistingMeshes] = useState(false);
  const [isDemolitionMeshes, setIsDemolitionMeshes] = useState(false);
  //
  const [totalEstimation, setTotalEstimation] = useState("");
  const [isSecondScreen, setSecondScreen] = useState(true);
  const [windowWidth, setWindowWidth] = useState(null);
  const [isFirstScreen, setFirstScreen] = useState(true);
  // const [isThirdScreen, setThirdScreen] = useState(true);

  const [selectGroups, setSelectGroups] = useState([]);
  const [isPriceView, setPriceView] = useState(true);
  const [isEstimationView, setEstimatioView] = useState(true);
  const [isGLOpend, setGLOpend] = useState(false);

  // project files variables
  let filesMeshes = [];
  let treeFilesMeshes = [];

  
  let additionalMeshes = [];
  let electricalMeshes = [];
  let mechanicalMeshes = [];
  let pipingMeshes = [];
  let switchMeshes = [];

  let [modelNumber, setModelNumber] = useState(0);
  let [modelsNames, setModelsNames] = useState([]);
  let [jsons, setJsons] = useState([]);
  let [models, setModels] = useState([]);

  let [additionalParamsPath] = useState([]);
  let [electricalCircuitsPath] = useState([]);
  let [mechanicalSystemsPath] = useState([]);
  let [pipingSystemsPath] = useState([]);
  let [switchSystemsPath] = useState([]);

  const [isThirdScreen, setThirdScreen] = useState(true);
  const [treeFilesData, setTreeFilesData] = useState([]);
  const [filesOpenNodes, setFilesOpenNodes] = useState([]);
  // The geometry of whichever Project Files branch is open: the mesh icon on a
  // row says only "the viewer has not built this", and on a streaming export
  // that is most rows most of the time. See hooks/useBranchGeometry.
  const branchGeometry = useBranchGeometry({
    projectId,
    sections: (treeFilesData && treeFilesData.length) ? treeFilesData : serverTree,
    openNodes: filesOpenNodes,
    WebGL,
    // No resolveRowUids here: this page has no row resolver (its files tree is
    // not the lazy index tree), so only branches whose rows are already
    // present are asked about. Passing a name that does not exist on this page
    // would be a ReferenceError at render.
  });
  const [filesMeshesArray, setFilesMeshes] = useState(null);

  const [additionalMeshesArray, setAdditionalMeshes] = useState(null);
  const [electricalMeshesArray, setElectricalMeshes] = useState(null);
  const [mechanicalMeshesArray, setMechanicalMeshes] = useState(null);
  const [pipingMeshesArray, setPipingMeshes] = useState(null);
  const [switchMeshesArray, setSwitchMeshes] = useState(null);

  const [isFilesMeshes, setIsFilesMeshes] = useState(false);
  const [clickedFilesChild, setClickedFilesChild] = useState([]);
  const [FiltersArr, setFiltersArr] = useState([]);

  const LaborinfoRef = useRef([]);
  const EquipinfoRef = useRef([]);
  const MatinfoRef = useRef([]);
  // const [meshQuantityInfoState, setMeshQuantityInfoState] = useState([]); // not working
  const meshQuantityInfoRef = useRef([]);

  useEffect(() => {
    const filtersPayload = [
      { ProjectFiles: treeFilesData.filter((item) => item) },
      { UnpricedComponents: treeUnmatchedData },
      { ExistingComponents: treeExistingData },
      { DemolitionComponents: treeDemolitionData },
      { PricedComponents: treeData },
      { AdditionalParams: additionalMeshesArray},
      { ElectricalCircuits: electricalMeshesArray},
      { MechanicalSystems: mechanicalMeshesArray},
    ];
    if (pipingMeshesArray) {
      filtersPayload.push({ PipingSystems: pipingMeshesArray });
    }
    if (switchMeshesArray) {
      filtersPayload.push({ SwitchSystems: switchMeshesArray });
    }
    setFiltersArr(filtersPayload);
  }, [
    treeFilesData,
    treeUnmatchedData,
    treeExistingData,
    treeDemolitionData,
    treeData,
    additionalMeshesArray,
    electricalMeshesArray,
    mechanicalMeshesArray,
    pipingMeshesArray,
    switchMeshesArray,
  ]);

  // project files variables
  console.log(neededTimeline)
  
  const { request: initializeAPI } = useHttp({
    requestCallback: async (d) =>
      await getJsonFile(neededTimeline.json).catch((e) => {
        // A non-JSON body means storage answered with an error page rather
        // than model data - the R2 404 shape. Say which fault it was.
        setModelError(classifyModelFetchError(e));
        return null;
      }).then(async (res) => {
        // An absent body is the other shape: the file is simply not there.
        if (!res) { setModelError((prev) => prev || NO_MODEL_FILE); return; }

        // Filter pass: streaming-pipeline files (manifest, tiles/, fragments/,
        // library.*) live in pathsmapping/paths but are consumed by
        // StreamingLoader directly via manifestUrl, NOT by this loop.
        // See ModelViewer.jsx for the full rationale. Both arrays are
        // zipped by index downstream so they MUST be filtered together.
        const rawMapping = neededTimeline?.zipInfo?.pathsmapping ?? [];
        const rawPaths = neededTimeline?.zipInfo?.paths ?? [];
        const legacyMapping = [];
        const legacyPaths = [];
        for (let i = 0; i < rawMapping.length; i++) {
          if (isStreamingPipelineEntry(rawMapping[i])) continue;
          legacyMapping.push(rawMapping[i]);
          legacyPaths.push(rawPaths[i]);
        }

        // Pair each document with ITS OWN component files, by name. This
        // used to walk the list positionally, and those indices line up
        // only when there is exactly one document — see
        // helpers/documentSets.js and the same fix in ModelViewer.
        // Project "Model files" filter (gear on the project card): documents
        // the user unticked are left out of the Project Files tree, the
        // records lookups and (in the streaming loader) the 3D model.
        const sourceFilter = await ensureSourceFilter(projectId);
        const documentSets = buildDocumentSets(legacyMapping, legacyPaths)
          .filter((d) => !sourceFilter.isTreePathHidden(d.tree));

        modelNumber = documentSets.length;
        setModelNumber(modelNumber);
        modelsNames = documentSets.map((d) => d.name);
        setModelsNames(modelsNames);

        var baseURL = url;
        if (project?.isIfcProject) {
          baseURL = project.isIfcProject ? IFC_Url : url;
        } else if (neededTimeline?.isIfcProject) {
          baseURL = neededTimeline.isIfcProject ? IFC_Url : url;
        }

        // Fresh arrays rather than push() onto the useState-held ones:
        // those references survive re-renders, so pushing accumulated
        // duplicates every time this ran.
        models = legacyPaths
          .filter((path) => path.endsWith(".glb") || path.endsWith(".glb.gz"))
          .map((path) => `${baseURL}/${path}`);
        jsons = documentSets.map((d) => d.tree);
        additionalParamsPath = documentSets.map((d) => d.additionalParam);
        electricalCircuitsPath = documentSets.map((d) => d.electricalCircuits);
        mechanicalSystemsPath = documentSets.map((d) => d.mechanicalSystems);
        pipingSystemsPath = documentSets.map((d) => d.pipingSystems);
        switchSystemsPath = documentSets.map((d) => d.switchSystems);

        setModels(models);
        setJsons(jsons);

        // The 3D starts here, before the record files are read.
        //
        // This construction used to sit below the loop that awaits
        // every document's records - 51 files and more than 1.5 GB of
        // JSON on SpaceX BA03, downloaded, gunzipped and parsed on the
        // main thread - so the viewer asked for its first fragment only
        // after all of it had landed. Nothing here needs a record file.
        // A new model replaces the old viewer; do not leave it running.
        try { if (WebGL.current && typeof WebGL.current.dispose === "function") WebGL.current.dispose(); } catch (e) { /* best effort */ }
        WebGL.current = new WebGlApp(
          viewerRef.current,
          {
            glbs: models,
            // NEW: streaming activates if a manifest exists for this project. The
            // URL hits the same /uploads/ static route the legacy GLB pipeline
            // uses, so no new backend wiring is needed. StreamingLoader falls
            // back to the legacy Loader (using `glbs`) automatically when the
            // manifest endpoint 404s.
            //
            // Timelines share the project's manifest — they're derived views
            // of the same underlying export, not separate exports. If we ever
            // generate per-timeline manifests (e.g. timeline-specific tile
            // filtering), this URL becomes per-timeline.
            manifestUrl: `${baseURL}/uploads/${projectId}/manifest.json.gz`,
          },
          {
            setClickedChild,
            setLoading,
            setError,
            setPercentsLoaded,
            setAllowToResize,
            setModal,
            setCoordsForPopover,
            findInJsonUsingViewer,
            setIsPopOver,
            onHoverMesh,
            selectedMesh,
            project,
          },
          line,
          false,
          project?.isIfcProject
            ? project?.isIfcProject
            : neededTimeline?.isIfcProject
            ? neededTimeline?.isIfcProject
            : false
        );
        attachBuildingGrid(WebGL.current.viewer, projectId);
        for (let i = 0; i < modelNumber; i++) {
          var mNumber = i;
          var mName = modelsNames[i];
          var mpath = jsons[i];
          var mAdditionalPath = additionalParamsPath[i];
          var mElectricalCircuitsPath = electricalCircuitsPath[i];
          var mMechanicalSystemsPath = mechanicalSystemsPath[i];
          var mPipingSystemsPath = pipingSystemsPath[i];
          var mSwitchSystemsPath = switchSystemsPath[i];

          await getCompressedJsonFile(
            mpath,
            project?.isIfcProject
              ? project?.isIfcProject
              : neededTimeline?.isIfcProject
              ? neededTimeline?.isIfcProject
              : false
          )
            .then((res) => {
              console.log("res", res);
              console.log("mNumber", mNumber);
              filesMeshes[mNumber] = generateRawMeshes(res); //generateMeshes(res);
              srcRef.current.filesMeshes = filesMeshes;

              // Per-file scope: each file's $id restarts at "1" (helpers/stableNodeId).
              treeFilesMeshes[mNumber] = scopeTreeIds(generateRawTree(res), `${projectId}:${mNumber}`);
              srcRef.current.treeFilesMeshes = treeFilesMeshes;
            })
            .catch((err) => console.log(err.message));

          // download additional json — guarded; the streaming-pipeline
          // filter above already drops manifest/tiles/fragments, but the
          // _AdditionalParam siblings may genuinely not exist for some
          // timelines. Skip the await in that case to avoid a /undefined
          // fetch.
          if (mAdditionalPath) {
            await getCompressedJsonFile(
              mAdditionalPath,
              project?.isIfcProject ? project?.isIfcProject : false
            )
              .then((res) => {
                additionalMeshes[mNumber] = res;
              })
              .catch((err) => {});
          }

          if (mElectricalCircuitsPath) {
            await getCompressedJsonFile(
              mElectricalCircuitsPath,
              project?.isIfcProject ? project?.isIfcProject : false
            )
              .then((res) => {
                electricalMeshes[mNumber] = res;
              })
              .catch((err) => {});
          }

          if (mMechanicalSystemsPath) {
            await getCompressedJsonFile(
              mMechanicalSystemsPath,
              project?.isIfcProject ? project?.isIfcProject : false
            )
              .then((res) => {
                mechanicalMeshes[mNumber] = res;
              })
              .catch((err) => {});
          }

          if (mPipingSystemsPath) {
            await getCompressedJsonFile(
              mPipingSystemsPath,
              project?.isIfcProject ? project?.isIfcProject : false
            )
              .then((res) => {
                pipingMeshes[mNumber] = res;
              })
              .catch((err) => {});
          }

          if (mSwitchSystemsPath) {
            await getCompressedJsonFile(
              mSwitchSystemsPath,
              project?.isIfcProject ? project?.isIfcProject : false
            )
              .then((res) => {
                switchMeshes[mNumber] = res;
              })
              .catch((err) => {});
          }
        }

        return res;
      }),
    onLoad: (res) => {
      // NOTHING ARRIVED, SO THERE IS NOTHING TO UNPACK. useHttp calls onLoad
      // unconditionally - `await onLoad(res)` runs whatever requestCallback
      // returned - and the two guards above deliberately return null (storage
      // answered with an error body) and undefined (the file is simply not
      // there). Without this line the very next statements read .FinalEstimation
      // off nothing: "Cannot read properties of undefined (reading
      // 'FinalEstimation')", which is the error 7764019f's guard UNCOVERED by
      // removing the parse crash that used to happen first.
      //
      // Returning here is not swallowing it. setModelError has already run, so
      // the page states which fault it was - this only stops a second, less
      // informative crash from replacing that message.
      //
      // `== null` RATHER THAN `!res`, and the difference is not style. The two
      // guards produce exactly null and undefined. `!res` would ALSO skip the
      // whole handler for 0, "" and false - and on those the old code did not
      // throw, it read undefined off a boxed primitive and carried on. So a
      // bare truthiness test would have been a behaviour change I had not
      // examined, on values nobody has seen but nobody has ruled out either.
      // Guard the shapes you actually produce.
      if (res == null) return;
      console.log("res**", res)
      setFilesMeshes([...filesMeshes]);
      setTreeFilesData([...treeFilesMeshes]);
      setTotalEstimation(res.FinalEstimation);

      // Every document's records, not just the first — these were spread
      // into a one-argument setState, which kept element 0 and discarded
      // the rest. Consumers look up by UniqueId, so N documents means all
      // of them concatenated; one document is unchanged.
      setAdditionalMeshes(flattenRecords(additionalMeshes));
      setElectricalMeshes(flattenRecords(electricalMeshes));
      setMechanicalMeshes(flattenRecords(mechanicalMeshes));
      if (pipingMeshes.length > 0) setPipingMeshes(flattenRecords(pipingMeshes));
      if (switchMeshes.length > 0) setSwitchMeshes(flattenRecords(switchMeshes));
      dispatch(setProjectfilesTree(treeFilesMeshes.filter((item) => item)));

      unmatchedMeshes = generateSubprojectMeshes(res.UnmatchedSubProjects);
      srcRef.current.unmatchedMeshes = unmatchedMeshes;

      // ONE SELECTION OVER FIVE TREES: the priced, unpriced, existing and
      // demolition trees are all built under the timeline's root $id, so a
      // root selected in one lit up in the other three. Each gets its own
      // scope, as each project file does (helpers/stableNodeId).
      treeUnmatchedMeshes = scopeTreeIds(generateSubprojectTree(
        res.$id,
        res.Title,
        res.UnmatchedSubProjects
      ), `${projectId}:timeline-unpriced`);
      srcRef.current.treeUnmatchedMeshes = treeUnmatchedMeshes;

      //
      existingMeshes = generateSubprojectMeshes(res.ExistingSubProjects);
      srcRef.current.existingMeshes = existingMeshes;
      demolitionMeshes = generateSubprojectMeshes(res.DemolitionSubprojects);
      srcRef.current.demolitionMeshes = demolitionMeshes;
      //
      //
      treeExistingMeshes = scopeTreeIds(generateSubprojectTree(
        res.$id,
        res.Title,
        res.ExistingSubProjects
      ), `${projectId}:timeline-existing`);
      srcRef.current.treeExistingMeshes = treeExistingMeshes;
      //
      treeDemolitionMeshes = scopeTreeIds(generateSubprojectTree(
        res.$id,
        res.Title,
        res.DemolitionSubprojects
      ), `${projectId}:timeline-demolition`);
      srcRef.current.treeDemolitionMeshes = treeDemolitionMeshes;

      meshes = generateSubprojectMeshes(res.SubProjects);
      srcRef.current.meshes = meshes;
      treeMeshes = scopeTreeIds(generateSubprojectTree(res.$id, res.Title, res.SubProjects), `${projectId}:timeline-priced`);
      srcRef.current.treeMeshes = treeMeshes;
      setMeshes(meshes);
      setTreeData(treeMeshes);
      console.log('actual Tree Data ******** ', treeMeshes);

      setTreeUnmatchedData(treeUnmatchedMeshes);
      setUnMatchedMeshes(unmatchedMeshes);

      //
      setTreeExistingData(treeExistingMeshes);
      setTreeDemolitionData(treeDemolitionMeshes);

      //
      //
      setExistingMeshes(existingMeshes);
      setDemolitionMeshes(demolitionMeshes);
      //
      console.log(...treeFilesMeshes, 'treeFilesMeshes')

      setFilesOpenNodes([
        ...filesOpenNodes,
        ...treeFilesMeshes.map((tv) => tv[0]?.key),
      ]);
      setOpenNodes([...openNodes, treeMeshes[0].key]);

      setUnmatchedOpenNodes([
        ...unmatchedOpenNodes,
        treeUnmatchedMeshes[0].key,
      ]);
      setExistingOpenNodes([...existingOpenNodes, treeExistingMeshes[0].key]);
      setDemolitionOpenNodes([
        ...demolitionOpenNodes,
        treeDemolitionMeshes[0].key,
      ]);
    },
    onError: (e) => {
      console.error(e);
      setError(true);
    },
  });

  const {
    error: cacheError,
    loading: cacheLoading,
    errorStatus: cacheErrorStatus,
    request: cacheRequest,
    refresh,
  } = useHttpWithCache({
    requestCallback: () => getProjects(),
    reduxSetter: (data) => {
      dispatch(setProjects(data.projects));
      dispatch(setCompanyUsers(data.users));
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects: projectsRedux,
      users: usersRedux,
    },
    allowToCash: true,
  });

  const {
    adminProjectsLoading,
    adminProjectsError,
    request: getAdminProjectsAPI,
  } = useHttpWithCache({
    requestCallback: () => mainAdminGetCompanies(),
    reduxSetter: (data) => {
      // No-op. The drill-in that actually populates projectsRedux
      // for admin users lives in its own useEffect below, gated by
      // adminDrillInFiredRef. The PRIOR shape of this setter
      // dispatched setProjects() with a NEW array ref on every
      // call — useHttpWithCache re-invokes reduxSetter with the
      // cache on every render whose reduxCash shape changed, so
      // a setter that dispatches state caused a render loop →
      // React #185 (the user just hit this on TimelineViewer cold
      // open). Keeping reduxSetter empty side-steps the loop;
      // the dedicated useEffect handles the one-shot drill-in.
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects: projectsRedux,
      users: usersRedux,
    },
    allowToCash: true,
  });



  const onHoverMesh = (id) => {
    const neededMesh = meshes.find((mesh) => mesh.UniqueId === id);
    setHoverMesh(neededMesh);
  };

  const jsonInfo = Maybe.of(
    (() => {
      if (
        isUnmatchedMeshes &&
        !isExistingMeshes &&
        !isFilesMeshes &&
        !isDemolitionMeshes
      ) {
        return {
          neededMeshesArray: unmatchedMeshesArray,
          neededClickedChild: clickedUnmatchedChild,
        };
      } else if (
        !isUnmatchedMeshes &&
        !isExistingMeshes &&
        !isFilesMeshes &&
        !isDemolitionMeshes
      ) {
        return {
          neededMeshesArray: meshesArray,
          neededClickedChild: clickedChild,
        };
      } else if (
        !isUnmatchedMeshes &&
        isExistingMeshes &&
        !isFilesMeshes &&
        !isDemolitionMeshes
      ) {
        return {
          neededMeshesArray: existingMeshesArray,
          neededClickedChild: clickedExistingChild,
        };
      } else if (
        !isUnmatchedMeshes &&
        !isExistingMeshes &&
        isFilesMeshes &&
        !isDemolitionMeshes
      ) {
        return {
          neededMeshesArray: filesMeshesArray,
          neededClickedChild: clickedFilesChild,
        };
      } else if (
        !isUnmatchedMeshes &&
        !isExistingMeshes &&
        !isFilesMeshes &&
        isDemolitionMeshes
      ) {
        return {
          neededMeshesArray: demolitionMeshesArray,
          neededClickedChild: clickedDemolitionChild,
        };
      }
    })()
  ).map(({ neededMeshesArray, neededClickedChild }) => {
    meshQuantityInfoRef.current = neededClickedChild;
    // console.log("from Timeline", {clickedChild})
    return neededClickedChild.length === 1
    ? neededClickedChild?.flatMap((i) => {
      return  neededMeshesArray?.flat()?.find((k) => k?.UniqueId === i?.UniqueId)
    })[0]
      : neededClickedChild.reduce(
          (totalObject, mesh) => {
            // console.log({ neededClickedChild })
            // setMeshQuantityInfoState(neededClickedChild);
            const sumProps = Object.assign(
              {},
              {
                LaborInfoTime:
                  totalObject.LaborInfoTime + mesh.LaborInfo
                    ? mesh.LaborInfo?.map((l) => l.TotalTime)
                    : 0,
                EquipmentInfoTime:
                  totalObject.EquipmentInfoTime + mesh.EquipmentInfo
                    ? mesh.EquipmentInfo?.map((l) => l.TotalTime)
                    : 0,

                LaborInfoPrice:
                  totalObject.LaborInfoPrice + mesh.LaborInfo
                    ? mesh.LaborInfo?.map((l) => l.TotalPrice)
                    : 0,
                EquipmentInfoPrice:
                  totalObject.EquipmentInfoPrice + mesh.EquipmentInfo
                    ? mesh.EquipmentInfo?.map((l) => l.TotalPrice)
                    : 0,

                Area: totalObject.Area + mesh.Area,
                Count: totalObject.Count + mesh.Count,
                Length: totalObject.Length + mesh.Length,
                Quantity: totalObject.Quantity + mesh.Quantity,
                Volume: totalObject.Volume + mesh.Volume,
                TotalPrice: totalObject.TotalPrice + mesh.TotalPrice,
              },
              typeof totalObject.Width === "number"
                ? {
                    Width: totalObject.Width + mesh.Width,
                  }
                : {},
              typeof totalObject.Depth === "number"
                ? {
                    Depth: totalObject.Depth + mesh.Depth,
                  }
                : {},
              typeof totalObject.TotalAmount === "number"
                ? {
                    TotalAmount: totalObject.TotalAmount + mesh.TotalAmount,
                  }
                : {},
              typeof totalObject.Dimentions === "number"
                ? {
                    Dimentions: totalObject.Dimentions + mesh.Dimentions,
                  }
                : {}
            );

            const stringProps = Object.assign(
              {},
              totalObject.Uniformat === mesh.Uniformat && totalObject.Uniformat
                ? { Uniformat: "-" }
                : { Uniformat: mesh.Uniformat },
              totalObject.Name !== mesh.Name && totalObject.Name
                ? { Name: "-" }
                : { Name: mesh.Name },
              totalObject.Type !== mesh.Type && totalObject.Type
                ? { Type: "-" }
                : { Type: mesh.Type },
              totalObject.MainCategory !== mesh.MainCategory &&
                totalObject.MainCategory
                ? { MainCategory: "-" }
                : { MainCategory: mesh.MainCategory },
              totalObject.CategoryName !== mesh.CategoryName &&
                totalObject.CategoryName
                ? { CategoryName: "-" }
                : { CategoryName: mesh.CategoryName },
              totalObject.LaborInfo !== mesh.LaborInfo && totalObject.LaborInfo
                ? { LaborInfoType: "-" }
                : {
                    LaborInfoType: mesh.LaborInfo
                      ? mesh.LaborInfo?.map((l) => l.Description).join(" | ")
                      : "-",
                  },
              totalObject.EquipmentInfo !== mesh.EquipmentInfo &&
                totalObject.EquipmentInfo
                ? { EquipmentInfoType: "-" }
                : {
                    EquipmentInfoType: mesh.EquipmentInfo
                      ? mesh.EquipmentInfo?.map((l) => l.Description).join(
                          " | "
                        )
                      : "-",
                  }
            );

            if (!totalObject.LaborInfo || totalObject.LaborInfo == null) {
              totalObject.LaborInfo = [];
            }
            totalObject.LaborInfo.push(
              ...totalObject.LaborInfo,
              mesh.LaborInfo ? mesh.LaborInfo : null
            );

            LaborinfoRef.current = [...totalObject.LaborInfo];

            // console.log("Total Labor Info - totalObject.LaborInfo: ", totalObject.LaborInfo, LaborinfoRef.current);

            if (
              !totalObject.EquipmentInfo ||
              totalObject.EquipmentInfo == null
            ) {
              totalObject.EquipmentInfo = [];
            }
            totalObject.EquipmentInfo.push(
              ...totalObject.EquipmentInfo,
              mesh.EquipmentInfo ? mesh.EquipmentInfo : null
            );
            EquipinfoRef.current = [...totalObject.EquipmentInfo];

            if (!totalObject.MaterialInfo || totalObject.MaterialInfo == null) {
              totalObject.MaterialInfo = [];
            }

            totalObject.MaterialInfo.push(...totalObject.MaterialInfo, {
              Types: mesh.MaterialNames,
              Name: mesh.Type,
              TotalAmount: mesh.TotalAmount,
              TotalPrice: mesh.TotalPrice,
            });
            MatinfoRef.current = [...totalObject.MaterialInfo];

            // setMaterialInfo(MaterialInfo);
            // setEquipmentInfo(EquipmentInfo);

            return { ...sumProps, ...stringProps };
          },
          neededClickedChild[0]
            ? {
                ...neededClickedChild[0],
                ...{
                  LaborInfoTime: 0,
                  EquipmentInfoTime: 0,
                  EquipmentInfoPrice: 0,
                  LaborInfoPrice: 0,
                  LaborInfo: [],
                  EquipmentInfo: [],
                  MaterialInfo: [],
                  Area: 0,
                  Count: 0,
                  Length: 0,
                  Quantity: 0,
                  Volume: 0,
                  TotalPrice: 0,
                },
              }
            : null
        );
  }).value;

  const jsonMeshesToJSX = useMemo(() => {
    return Maybe.of(treeData).map((tree) => (
      <TreeViewMenu cacheSearch={false} key="matched" openNodes={openNodes} data={tree}>
        {({ items }) => {
          return items.map((item, index) => {
            return (
              <TreeViewerItem
                item={item}
                index={index}
                clickedChild={clickedChild}
                setClickedChild={setClickedChild}
                selectGroups={selectGroups}
                setSelectGroups={setSelectGroups}
                key={item.key || item.id || `item-${index}-${item.uid || ''}`}
                selectedMesh={selectedMesh}
                WebGL={WebGL}
                tree={tree}
                setTreeData={setTreeData}
                setOpenNodes={setOpenNodes}
                isUnmatchedMeshes={() => setIsUnmatchedMeshes(false)}
                isExistingMeshes={() => setIsExistingMeshes(false)}
                isDemolitionMeshes={() => setIsDemolitionMeshes(false)}
                isFilesMeshes={() => setIsFilesMeshes(false)}
                onSelectionStart={(isCtrl) => { if (!isCtrl) clearOtherTrees("matched"); }}
                selectors={{
                  prevMeshes: "prevMeshes",
                  prevMaterials: "prevMaterials",
                  color: "blue",
                }}
              />
            );
          });
        }}
      </TreeViewMenu>
    )).value;
  }, [ clickedChild, openNodes]);

  const jsonUnmatchedMeshesToJSX = useMemo(
    () =>
      Maybe.of(treeUnmatchedData).map((tree) => (
        <TreeViewMenu cacheSearch={false}
          key="unmatched"
          data={tree}
          openNodes={unmatchedOpenNodes}
        >
          {({ items }) => {
            return items.map((item, index) => {
              return (
                <TreeViewerItem
                  item={item}
                  index={index}
                  selectGroups={selectGroups}
                  setSelectGroups={setSelectGroups}
                  key={item.key || item.id || `item-${index}-${item.uid || ''}`}
                  clickedChild={clickedUnmatchedChild}
                  setClickedChild={setClickedUnmatchedChild}
                  selectedMesh={selectedMesh}
                  WebGL={WebGL}
                  tree={tree}
                  setTreeData={setTreeUnmatchedData}
                  setOpenNodes={setUnmatchedOpenNodes}
                  isUnmatchedMeshes={() => setIsUnmatchedMeshes(true)}
                  isExistingMeshes={() => setIsExistingMeshes(false)}
                  isDemolitionMeshes={() => setIsDemolitionMeshes(false)}
                  isFilesMeshes={() => setIsFilesMeshes(false)}
                  onSelectionStart={(isCtrl) => { if (!isCtrl) clearOtherTrees("unmatched"); }}
                  selectors={{
                    prevMeshes: "prevUnmatchedMeshes",
                    prevMaterials: "prevUnmatchedMaterials",
                    color: "red",
                  }}
                />
              );
            });
          }}
        </TreeViewMenu>
      )).value,
    [unmatchedOpenNodes, treeUnmatchedData, clickedUnmatchedChild]
  );

  const jsonExistingMeshesToJSX = useMemo(
    () =>
      Maybe.of(treeExistingData).map((tree) => (
        <TreeViewMenu cacheSearch={false}
          key="existing"
          data={tree}
          openNodes={existingOpenNodes}
        >
          {({ items }) => {
            return items.map((item, index) => {
              return (
                <TreeViewerItem
                  item={item}
                  index={index}
                  selectGroups={selectGroups}
                  setSelectGroups={setSelectGroups}
                  key={item.key || item.id || `item-${index}-${item.uid || ''}`}
                  clickedChild={clickedExistingChild}
                  setClickedChild={setClickedExistingChild}
                  selectedMesh={selectedMesh}
                  WebGL={WebGL}
                  tree={tree}
                  setTreeData={setTreeExistingData}
                  setOpenNodes={setExistingOpenNodes}
                  isUnmatchedMeshes={() => setIsUnmatchedMeshes(false)}
                  isExistingMeshes={() => setIsExistingMeshes(true)}
                  isDemolitionMeshes={() => setIsDemolitionMeshes(false)}
                  isFilesMeshes={() => setIsFilesMeshes(false)}
                  onSelectionStart={(isCtrl) => { if (!isCtrl) clearOtherTrees("existing"); }}
                  selectors={{
                    prevMeshes: "prevExistingMeshes",
                    prevMaterials: "prevExistingMaterials",
                    color: "purple",
                  }}
                />
              );
            });
          }}
        </TreeViewMenu>
      )).value,
    [existingOpenNodes, treeExistingData, clickedExistingChild]
  );

  const jsonDemolitionMeshesToJSX = useMemo(
    () =>
      Maybe.of(treeDemolitionData).map((tree) => (
        <TreeViewMenu cacheSearch={false}
          key="demolition"
          data={tree}
          openNodes={demolitionOpenNodes}
        >
          {({ items }) => {
            return items.map((item, index) => {
              return (
                <TreeViewerItem
                  item={item}
                  index={index}
                  selectGroups={selectGroups}
                  setSelectGroups={setSelectGroups}
                  key={item.key || item.id || `item-${index}-${item.uid || ''}`}
                  clickedChild={clickedDemolitionChild}
                  setClickedChild={setClickedDemolitionChild}
                  selectedMesh={selectedMesh}
                  WebGL={WebGL}
                  tree={tree}
                  setTreeData={setTreeDemolitionData}
                  setOpenNodes={setDemolitionOpenNodes}
                  isUnmatchedMeshes={() => setIsUnmatchedMeshes(false)}
                  isExistingMeshes={() => setIsExistingMeshes(false)}
                  isDemolitionMeshes={() => setIsDemolitionMeshes(true)}
                  isFilesMeshes={() => setIsFilesMeshes(false)}
                  onSelectionStart={(isCtrl) => { if (!isCtrl) clearOtherTrees("demolition"); }}
                  selectors={{
                    prevMeshes: "prevDemolitionMeshes",
                    prevMaterials: "prevDemolitionMaterials",
                    color: "brown",
                  }}
                />
              );
            });
          }}
        </TreeViewMenu>
      )).value,
    [demolitionOpenNodes, treeDemolitionData, clickedDemolitionChild]
  );

  const jsonFilesMeshesToJSX = useMemo(() => {
    // The server's branch is drawn only when the legacy loop produced nothing,
    // so a project still published the old way behaves exactly as before.
    const sections = (treeFilesData && treeFilesData.length) ? treeFilesData : (serverTree || []);
    return sections.map((section, mainIndex) => {
      return Maybe.of(section).map((tree) => (
        <TreeViewMenu cacheSearch={false} key={`files-${mainIndex}`} openNodes={filesOpenNodes} data={tree}>
          {({ items }) => {
            return items.map((item, index) => {
              return (
                <TreeViewerItem
                  item={item}
                  index={index}
                  clickedChild={clickedFilesChild}
                  setClickedChild={setClickedFilesChild}
                  selectGroups={selectGroups}
                  setSelectGroups={setSelectGroups}
                  key={item.key || item.id || `item-${index}-${item.uid || ''}`}
                  selectedMesh={selectedMesh}
                  WebGL={WebGL}
                  tree={tree}
                  setTreeData={(updatedSection) => {
                    [...treeFilesData][mainIndex] = updatedSection;
                    setTreeFilesData([...treeFilesData]);
                  }}
                  setOpenNodes={setFilesOpenNodes}
                  askedUids={branchGeometry.askedUids}
                  untiledUids={branchGeometry.untiledUids}
                  meshVersion={branchGeometry.meshVersion}
                  isUnmatchedMeshes={() => setIsUnmatchedMeshes(false)}
                  isExistingMeshes={() => setIsExistingMeshes(false)}
                  isDemolitionMeshes={() => setIsDemolitionMeshes(false)}
                  isFilesMeshes={() => setIsFilesMeshes(true)}
                  onSelectionStart={(isCtrl) => { if (!isCtrl) clearOtherTrees("files"); }}
                  selectors={{
                    prevMeshes: "prevFilesMeshes",
                    prevMaterials: "prevFilesMaterials",
                    color: "orange",
                  }}
                />
              );
            });
          }}
        </TreeViewMenu>
      )).value;
    });
    // branchGeometry is named because the rows read it: without it the memo
    // holds the old rows and a mesh that has just arrived is not drawn.
  }, [treeFilesData, clickedFilesChild, filesOpenNodes, serverTree, branchGeometry]);

  // Single-tree-at-a-time enforcement.
  //
  // Plain click in any tree (matched / unmatched / existing / demolition / files)
  // wipes the OTHER four trees' clickedChild state. Ctrl-click extends/toggles
  // within a tree without affecting siblings. Mirrors the C# UI rule and the
  // SocketViewer 'click is exclusive' rule so all clients converge on the same
  // single-tree selection model.
  //
  // 'keepKey' identifies which tree the click belongs to and should be kept.
  //
  // We clear in TWO places:
  //
  //   1. React state (setClickedXxxChild([])) — drives the on-screen
  //      tree highlight (rows turn back to neutral).
  //
  //   2. Viewer-side selection state via onClickChildInList('reset',...)
  //      with each non-kept tree's selectors. This wipes
  //      viewer.cachedMeshSelections[treeIndex], the viewer's prev-meshes
  //      list, and re-runs the highlight revert. Without this, the
  //      viewer keeps the old selections in its per-tree cache, and
  //      anything that aggregates across trees (the old toggleIsolate
  //      union, future selection-snapshot features) silently includes
  //      them. The fix in toggleIsolate stopped reading
  //      cachedMeshSelections, but the staleness was the real bug —
  //      this clears it at the source.
  const TREE_SELECTORS = {
    matched:    { prevMeshes: "prevMeshes",           prevMaterials: "prevMaterials",           color: "blue",   treeIndex: 0 },
    unmatched:  { prevMeshes: "prevUnmatchedMeshes",  prevMaterials: "prevUnmatchedMaterials",  color: "red",    treeIndex: 1 },
    existing:   { prevMeshes: "prevExistingMeshes",   prevMaterials: "prevExistingMaterials",   color: "purple", treeIndex: 2 },
    demolition: { prevMeshes: "prevDemolitionMeshes", prevMaterials: "prevDemolitionMaterials", color: "brown",  treeIndex: 3 },
    files:      { prevMeshes: "prevFilesMeshes",      prevMaterials: "prevFilesMaterials",      color: "orange", treeIndex: 4 },
  };
  const clearOtherTrees = (keepKey) => {
    if (keepKey !== "matched") setClickedChild([]);
    if (keepKey !== "unmatched") setClickedUnmatchedChild([]);
    if (keepKey !== "existing") setClickedExistingChild([]);
    if (keepKey !== "demolition") setClickedDemolitionChild([]);
    if (keepKey !== "files") setClickedFilesChild([]);

    const viewer = WebGL.current?.viewer;
    if (!viewer || typeof viewer.onClickChildInList !== 'function') return;
    Object.entries(TREE_SELECTORS).forEach(([key, sel]) => {
      if (key === keepKey) return;
      viewer.onClickChildInList('reset', false, sel, false, false);
    });
  };

  const pickMeshInNeededTree = (
    clicked,
    treeMeshes,
    setOpenNodes,
    setClickedChild,
    keyIsCtrl,
    selectors,
    treeKey  // NEW: 'matched' | 'unmatched' | 'existing' | 'demolition' | 'files'
  ) => {
    setSelectGroups([]);
    if (!clicked) {
      setModal(true);
    } else {
      // Plain click in any tree clears the other trees' selections so only
      // one tree at a time holds a selection. Ctrl-click extends, so don't
      // touch siblings in that case.
      if (!keyIsCtrl && treeKey) {
        clearOtherTrees(treeKey);
      }
      // THE CLICK CAME IN ONE OF TWO SHAPES. findInJsonUsingViewer's four
      // legacy branches pass ONE record; a group click in TreeViewerItem
      // passes a list. The old guard assigned newClicked only when the list
      // held more than one entry, so for a single record - every 3D click -
      // it stayed undefined and findRowForRecord searched for nothing:
      // staging drive 2026-10-21, meshFound true and then no expansion, no
      // highlight, no scroll report at all. recordFromClick is that rule,
      // shared with the other viewer pages.
      const newClicked = recordFromClick(clicked);
      console.log("pickMeshInNeededTree => clicked ", clicked);

      let path;

      // ONE CALL, EVERY TREE SHAPE (owner, 2026-10-21: "pull the code from
      // all other viewers and fix same issue"). The two branches below asked
      // for node.id === $id, which is a JSON.NET reference number: a node
      // built without one carries a derived id and the search matched
      // nothing - no expansion, no highlight, no scroll. findRowForRecord
      // asks by the leaf id we inserted, then Revit's UniqueId, then $id,
      // searches every root rather than the first, and takes the trees as a
      // list instead of being handed one where the id belonged.
      path = findRowForRecord(treeMeshes, newClicked).path;

      clicked = newClicked;

      console.log("path from pick needed mesh ", path);

      const nodesKey = expandKeysForPath(path);
      nodesKey.forEach((nodeKey) => {
        setOpenNodes((s) => {
          if (s?.includes(nodeKey)) {
            return s;
          }
          return [...s, nodeKey];
        });
      });
      setClickedChild((s) => {
        if (keyIsCtrl) {
          if (s.find((mesh) => mesh.UniqueId === clicked.UniqueId)) {
            const neededIndex = s.findIndex(
              (mesh) => mesh.UniqueId === clicked.UniqueId
            );
            return [...s.slice(0, neededIndex), ...s.slice(neededIndex + 1)];
          }
          return [...s, clicked];
        } else {
          return [clicked];
        }
      });
      setScrollId(scrollTargetId(path));
      WebGL.current.viewer.onClickChildInList(
        clicked ? clicked.UniqueId : "",
        keyIsCtrl,
        selectors,
        false,
        false
      );
      selectedMesh.current = clicked.UniqueId;
    }
  };

  const findInJsonUsingViewer = (id, keyIsCtrl) => {
    // READ THE REF, AND NEVER CALL .find ON A NULL. The five lines this
    // replaced each did `<source>.find(...)` against a `let` that React resets
    // every render and that starts as null, from inside a closure the viewer
    // captured at mount - so a click threw before it reached any branch.
    const src = srcRef.current || {};
    const list = (v) => (Array.isArray(v) ? v : []);
    const byUid = (v) => list(v).find((mesh) => mesh && mesh.UniqueId === id);

    const clickedUsualMesh = byUid(src.meshes);
    const clickedUnpricedMesh = byUid(src.unmatchedMeshes);
    const clickedExistingMesh = byUid(src.existingMeshes);
    const clickedDemolitionMesh = byUid(src.demolitionMeshes);
    // Project files: one entry per file, undefined where that file does not
    // hold the element. `.some(Boolean)` is the test, never the array itself.
    const { perFile: clickedFilesMesh, found: foundInFiles } =
      findClickedMesh(src.filesMeshes, id);

    if (!clickedUsualMesh && !clickedUnpricedMesh && !clickedExistingMesh
        && !clickedDemolitionMesh && !foundInFiles) {
      console.warn("[timeline] no tree row for the clicked element", {
        uniqueId: id,
        counts: {
          meshes: list(src.meshes).length,
          unmatched: list(src.unmatchedMeshes).length,
          existing: list(src.existingMeshes).length,
          demolition: list(src.demolitionMeshes).length,
          files: list(src.filesMeshes).length,
        },
      });
      // THE LEGACY LOOPS HAVE NOTHING ON A STREAMING EXPORT, so ask the
      // server - the same /model-tree the model viewer uses, not a second
      // copy of the mapping (owner, 2026-10-20: the viewer must work on any
      // tree structure, on every page).
      (async () => {
        try {
          const loc = await treeLocate(projectId, id);
          const open = openKeysFromLocate(loc);
          const leaf = leafKeyFromLocate(loc);
          const [fams, types, leaves] = await Promise.all([
            treeChildren(projectId, { category: loc.element.category }),
            treeChildren(projectId, { category: loc.element.category, family: loc.element.family }),
            treeChildren(projectId, {
              category: loc.element.category, family: loc.element.family, type: loc.element.typeName,
              skip: loc.page * loc.pageSize, limit: loc.pageSize,
            }),
          ]);
          // ONE RENDER, NOT SEVEN. This block runs after two awaits, and
          // React 16 batches updates only inside its own event handlers - so
          // each of these rendered the whole tree separately, which on the
          // model viewer measured 2,924ms for the selection update alone
          // (owner, 2026-10-21: "when i click on something it hangs"). The
          // rest of this page's click path is synchronous and React batches
          // it already; this branch is the one place that needs saying.
          batch(() => {
          setServerTree(serverBranch(loc, fams, types, leaves));
          setFilesOpenNodes((prev) => [...new Set([...(prev || []), ...open])]);
          setClickedFilesChild([{ UniqueId: id, Name: loc.element.name }]);
          setIsFilesMeshes(true);
          // THE ROW'S DOM ID, NOT THE LIBRARY KEY. leafKeyFromLocate returns
          // the ancestors joined with "/", which is what openNodes wants;
          // TreeViewerItem renders id={item.id}. Scrolling to the key found
          // nothing (model viewer, 2026-10-21: tries 21, rowInDom false).
          setScrollId(leafRowIdFromLocate(loc));
          setModal(false);
          setNoMeshReason("");
          });
        } catch (e) {
          setNoMeshReason(e && e.status === 404
            ? "This element is drawn in the model but is not in the published commit this page is reading."
            : "This element is in the model but its details could not be read just now. Try again in a moment.");
          setModal(true);
        }
      })();
      return;
    }
    //
    if (clickedUnpricedMesh) {
      setIsUnmatchedMeshes(true);
      setIsExistingMeshes(false);
      setIsDemolitionMeshes(false);
      setIsFilesMeshes(false);
      pickMeshInNeededTree(
        clickedUnpricedMesh,
        src.treeUnmatchedMeshes,
        setUnmatchedOpenNodes,
        setClickedUnmatchedChild,
        keyIsCtrl,
        {
          prevMeshes: "prevUnmatchedMeshes",
          prevMaterials: "prevUnmatchedMaterials",
          color: "red",
        },
        "unmatched"
      );
    } else if (clickedExistingMesh) {
      setIsExistingMeshes(true);
      setIsUnmatchedMeshes(false);
      setIsDemolitionMeshes(false);
      setIsFilesMeshes(false);
      pickMeshInNeededTree(
        clickedExistingMesh,
        src.treeExistingMeshes,
        setExistingOpenNodes,
        setClickedExistingChild,
        keyIsCtrl,
        {
          prevMeshes: "prevExistingMeshes",
          prevMaterials: "prevExistingMaterials",
          color: "purple",
        },
        "existing"
      );
    } else if (clickedUsualMesh) {
      setIsUnmatchedMeshes(false);
      setIsExistingMeshes(false);
      setIsDemolitionMeshes(false);
      setIsFilesMeshes(false);
      pickMeshInNeededTree(
        clickedUsualMesh,
        src.treeMeshes,
        setOpenNodes,
        setClickedChild,
        keyIsCtrl,
        {
          prevMeshes: "prevMeshes",
          prevMaterials: "prevMaterials",
          color: "blue",
        },
        "matched"
      );
    } else if (clickedDemolitionMesh) {
      setIsUnmatchedMeshes(false);
      setIsExistingMeshes(false);
      setIsDemolitionMeshes(true);
      setIsFilesMeshes(false);
      pickMeshInNeededTree(
        clickedDemolitionMesh,
        src.treeDemolitionMeshes,
        setDemolitionOpenNodes,
        setClickedDemolitionChild,
        keyIsCtrl,
        {
          prevMeshes: "prevDemolitionMeshes",
          prevMaterials: "prevDemolitionMaterials",
          color: "brown",
        },
        "demolition"
      );
    } else if (clickedFilesMesh) {
      setIsFilesMeshes(true);
      setIsDemolitionMeshes(false);
      setIsExistingMeshes(false);
      setIsUnmatchedMeshes(false);
      pickMeshInNeededTree(
        clickedFilesMesh,
        treeFilesMeshes,
        setFilesOpenNodes,
        setClickedFilesChild,
        keyIsCtrl,
        {
          prevMeshes: "prevFilesMeshes",
          prevMaterials: "prevFilesMaterials",
          color: "orange",
        },
        "files"
      );
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (!projectsRedux && !line) {
      if (isMountedRef.current) {
        if(userInfoRedux?.admin){
          getAdminProjectsAPI()
        }
        else{
          cacheRequest();
        }
      }
    } else {
      //   initializeAPI();
    }
    return () => (isMountedRef.current = false);
  }, [projectsRedux]);

  useEffect(() => {
    isMountedRef.current = true;
    // ONE SHARED SCROLL, CONVERGENT (owner, 2026-10-21: "check that every
    // other viewer is also working correctly", then "do both").
    //
    // This looked for the row ONCE - so a row drawn by the render the click
    // triggers was simply missed - and then used scrollIntoView with
    // behavior "smooth" and block "nearest". On the model viewer that pair
    // measurably did nothing: smooth over 100,000px is asynchronous and
    // unreliable at that distance, and "nearest" is a no-op for a row already
    // judged near. Aiming once was wrong too - the layout moves as the render
    // commits, measured 7,000px out four times in five.
    //
    // scrollRowToCentre waits for the row, finds the ancestor that actually
    // scrolls, positions it directly and then corrects until the row stays
    // centred. Same code as the model viewer now, rather than this page's own
    // version of it.
    const cancel = scrollRowToCentre(scrollId, {
      isAlive: () => isMountedRef.current,
      report: (r) => reportClientError("timeline/scroll", { message: JSON.stringify(r) }),
    });
    return () => { cancel(); isMountedRef.current = false; };
  }, [scrollId]);

  useEffect(() => {
    if (cacheErrorStatus) {
      const stringError = String(cacheErrorStatus);
      addNotification(stringError, "danger");
      if (stringError.toLowerCase()?.includes("unexpected token")) {
        logOut();
        history.push("/");
      }
    }
  }, [cacheErrorStatus]);

  useEffect(() => {
    isMountedRef.current = true;
    if (!isFirstScreen || !isSecondScreen || !isThirdScreen) {
      if (isMountedRef.current) {
        setAllowToResize(true);
      }
    } else {
      setAllowToResize(true);
    }
    return () => (isMountedRef.current = false);
  }, [isFirstScreen, isSecondScreen, isThirdScreen]);

  const handleChangeViewPrice = (isVisiblePrice, isVisibleEstimation) => {
    if (!personal) {
      setPriceView(isVisiblePrice);
      setEstimatioView(isVisibleEstimation);
    }
  };

  const infoPanel = (
    <div
      style={{
        minWidth: `${isFirstScreen ? resize?.panels[1] || 300 : ""}px`,
        maxWidth: `${isFirstScreen ? resize?.panels[1] || 300 : ""}px`,
      }}
      className="viewer-outer-div"
    >
      <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
        <div className="d-flex align-items-center viewer-header-item ">
          <img src={estimationImg} className="estimation-icon" />
          Estimation Details:
        </div>

        <MDBBox
          onClick={() => setFirstScreen((s) => !s)}
          className={`viewer-icon ${
            !isFirstScreen ? "viewer-icon-rotate" : ""
          }`}
        >
          <CloseIcon />
        </MDBBox>
      </div>
    </div>
  );

  const pricedComponent = (
    <div
      style={{
        minWidth: `${isSecondScreen ? resize?.panels[2] || 300 : ""}px`,
        maxWidth: `${isSecondScreen ? resize?.panels[2] || 300 : ""}px`,
      }}
      className="viewer-outer-div"
    >
      <div className="px-2 d-flex align-items-center viewer-header-item viewer-gapping overflow-hidden">
        <MDBBox className="viewer-header-item d-flex align-items-center">
          <img src={pricedImg} className="priced-img" />
          Priced component:
        </MDBBox>
        <MDBBox className="flex-grow-1 text-truncate viewer-header-item ml-2">
          {clickedChild[clickedChild.length - 1]
            ? `${clickedChild[clickedChild.length - 1].Name}:${
                clickedChild[clickedChild.length - 1].Type
              }`
            : ""}
        </MDBBox>
        <MDBBox
          onClick={() => setSecondScreen((s) => !s)}
          className={`viewer-icon ${
            !isSecondScreen ? "viewer-icon-rotate" : ""
          }`}
        >
          <CloseIcon />
        </MDBBox>
      </div>
    </div>
  );

  const ProjectPanel = (
    <div
      style={{
        minWidth: `${isThirdScreen ? resize?.panels[3] || 300 : ""}px`,
        maxWidth: `${isThirdScreen ? resize?.panels[3] || 300 : ""}px`,
      }}
      className="viewer-outer-div"
    >
      {/* <i className="fa fa-file"></i> */}
      <div className="px-2 d-flex justify-content-between align-items-center overflow-hidden viewer-header-item viewer-gapping">
        <MDBBox className="viewer-header-item d-flex align-items-center">
          <img src={projectIcon} className="project-icon" />
          Project Files
        </MDBBox>
        <MDBBox
          onClick={() => setThirdScreen((s) => !s)}
          className={`viewer-icon ${
            !isThirdScreen ? "viewer-icon-rotate" : ""
          }`}
        >
          <CloseIcon />
        </MDBBox>
      </div>
    </div>
  );

  let timelineArray = [infoPanel, pricedComponent, ProjectPanel];

  // The symbol no longer decides WHETHER a price is shown - see
  // hoverPriceLabel.js. The two sources for it are collapsed here: the
  // state at the top of this component is set FROM neededTimeline, so the
  // live value wins and the state is the fallback.
  const hoverMeshInfo = () =>
    hoverPriceLabel(hoverMesh, neededTimeline?.currencysymb || currencysymb, numeral);

  const price = clickedChild?.reduce((totalPrice, prevMesh) => {
    const laborTotal = prevMesh?.LaborInfo?.reduce((sum, labor) => sum + (labor?.TotalPrice || 0), 0) || 0;
    const equipmentTotal = prevMesh?.EquipmentInfo?.reduce((sum, equipment) => sum + (equipment?.TotalPrice || 0), 0) || 0;
    const mainTotalPrice = prevMesh?.TotalPrice || 0;
    return totalPrice + mainTotalPrice + laborTotal + equipmentTotal;
  }, 0).toFixed(2);
  
  // console.log('line =>', line);
  // console.log('neededTimeline =>', neededTimeline);

  return (
    <div className="timeline-viewer-container">
      <MDBBox className="viewer d-flex overflow-hidden flex-wrap">
        <MDBBox className="viewer-header viewer-header1 d-flex w-100">
          {/* { timelineArray.map((el) => {
          return (<el />)
        }) }  */}

          {/* {infoPanel}
					{pricedComponent}
					{ProjectPanel} */}

          {isFirstScreen && isSecondScreen && isThirdScreen && (
            <>
              {infoPanel}
              {pricedComponent}
              {ProjectPanel}
            </>
          )}

          {!isFirstScreen && isSecondScreen && isThirdScreen && (
            <>
              {pricedComponent}
              {ProjectPanel}
              {infoPanel}
            </>
          )}
          {isFirstScreen && !isSecondScreen && isThirdScreen && (
            <>
              {infoPanel}
              {ProjectPanel}
              {pricedComponent}
            </>
          )}
          {isFirstScreen && isSecondScreen && !isThirdScreen && (
            <>
              {infoPanel}
              {pricedComponent}
              {ProjectPanel}
            </>
          )}
          {!isFirstScreen && !isSecondScreen && isThirdScreen && (
            <>
              {ProjectPanel}
              {infoPanel}
              {pricedComponent}
            </>
          )}
          {!isFirstScreen && isSecondScreen && !isThirdScreen && (
            <>
              {pricedComponent}
              {infoPanel}
              {ProjectPanel}
            </>
          )}
          {isFirstScreen && !isSecondScreen && !isThirdScreen && (
            <>
              {infoPanel}
              {pricedComponent}
              {ProjectPanel}
            </>
          )}
          {!isFirstScreen && !isSecondScreen && !isThirdScreen && (
            <>
              {infoPanel}
              {pricedComponent}
              {ProjectPanel}
            </>
          )}

          {/* /* last container header */}

          {(!line || line.rule.prices) && (
            <div className="d-flex align-items-center justify-content-between flex-grow-1 px-2 viewer-header-item viewer-gapping h-100">
              <MDBBox tag="span" className="viewer-header-item">
                Total Cost :
                {numeral(totalEstimation).format(
                  `${neededTimeline?.currencysymb} 0,0.00`
                )}
              </MDBBox>

              {
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="checkboxTooltip"
                  />
                  <label
                    htmlFor="checkboxTooltip"
                    className="custom-control-label custom-control-label1 viewer-header-item"
                  >
                    Enable Tooltip prices
                  </label>
                </div>
              }
              <MDBBox tag="span" className="viewer-header-item">
                Selection Cost :{" "}
                {numeral(price).format(
                  `${neededTimeline?.currencysymb} 0,0.00`
                )}
              </MDBBox>
              {project ? (
                <MDBBox tag="span" className="viewer-header-item">
                  <div className="d-flex align-items-center project-admin-header ">
                    <i className="fa fa-home mr-2"></i> Project:
                    <strong className="ml-2">{project.title}</strong>
                  </div>
                </MDBBox>
              ) : null}
            </div>
          )}
        </MDBBox>

        {/* resizable main container starts */}
        <ResizableViewer
          width="100%"
          height="100%"
          panelsSize={[30, 70]}
          WebGlApp={WebGL.current}
          setResize={setResize}
          isFirstScreen={isFirstScreen}
          isSecondScreen={isSecondScreen}
          isThirdScreen={isThirdScreen}
          allowToResize={allowToResize}
        >
          {/* estimation-info container starts */}
          <MDBBox className="overflow-auto h-100 inner_resizable">
            <MDBListGroup>
              {jsonInfo ? (
                Object.entries(jsonInfo).map((keyAndValue) => {
                  const [key, value] = keyAndValue;
                  if (key === "$id") {
                    return null;
                  }

                  if (
                    line &&
                    !line.rule.prices &&
                    (key === "TotalPrice" || key === "UnitPrice")
                  ) {
                    return null;
                  }

                  return (
                    <MDBListGroupItem
                      key={key}
                      className="border border-light py-1 text-truncate"
                    >
                      {key === "TotalPrice"
                        ? `${key}: ${numeral(value).format(
                            `${neededTimeline?.currencysymb} 0,0.00`
                          )}`
                        : `${key}: ${value}`}
                    </MDBListGroupItem>
                  );
                })
              ) : isPriceView || isEstimationView ? (
                <MDBBox className="p-0">
                  <CollapsibleTable
                    data={summary}
                    currencysymb={neededTimeline?.currencysymb}
                    expanded={true}
                    priceView={isPriceView}
                    myClassName="modal-side-table"
                  />
                </MDBBox>
              ) : null}
            </MDBListGroup>
          </MDBBox>

          {/* Mashes container starts */}
          <div className="h-100 overflow-hidden inner_resizable">
            <ResizablePanels
              displayDirection="column"
              width="100%"
              height="100%"
              panelsSize={[25, 25, 25, 25]}
              resizerSize="3px"
              resizerColor="#f2f2f2"
              sizeUnitMeasure="%"
            >
              {/* priced container starts */}
              <MDBBox className="h-100 overflow-auto ">
                {jsonMeshesToJSX}
                {loading ? (
                  <MDBBox className="w-100">
                    <Loading color="black" text="Loading component..." />
                  </MDBBox>
                ) : null}
              </MDBBox>

              {/* unpriced container starts */}
              <MDBBox className="h-100 ">
                <div className="px-2 position-sticky viewer-lowerheader text-bid">
                  <MDBBox className="d-flex align-items-center h-100">
                    <img src={unpricedImg} className="unpriced-img" />

                    <MDBBox
                      tag="span"
                      className="viewer-header-item d-flex align-items-center"
                    >
                      Unpriced components
                    </MDBBox>
                  </MDBBox>
                </div>
                <MDBBox className="viewer-lowertree overflow-auto">
                  {jsonUnmatchedMeshesToJSX}
                  {loading ? (
                    <MDBBox className="w-100">
                      <Loading color="black" text="Loading component..." />
                    </MDBBox>
                  ) : null}
                </MDBBox>
              </MDBBox>

              {/* Existing container starts */}
              <MDBBox className="h-100">
                <div className="px-2 position-sticky viewer-lowerheader text-bid">
                  <MDBBox className="h-100">
                    <MDBBox
                      tag="span"
                      className="viewer-header-item d-flex align-items-center h-100"
                    >
                      {/* <div className="component-sign-label bg-existing">
                      <i className="fa fa-usd text-white"></i>
                      <i className="fa fa-minus bg-existing"></i>
                    </div> */}
                      <img src={existingImg} className="existing-img" />
                      Existing components
                    </MDBBox>
                  </MDBBox>
                </div>
                <MDBBox className="viewer-lowertree overflow-auto">
                  {jsonExistingMeshesToJSX}
                  {loading ? (
                    <MDBBox className="w-100">
                      <Loading color="black" text="Loading component..." />
                    </MDBBox>
                  ) : null}
                </MDBBox>
              </MDBBox>

              {/* Demolition container starts */}
              <MDBBox className="h-100">
                <div className="px-2 position-sticky viewer-lowerheader text-bid">
                  <MDBBox className="h-100">
                    <MDBBox
                      tag="span"
                      className="viewer-header-item d-flex align-items-center h-100"
                    >
                      {/* <div className="component-sign-label bg-demolition">
                      <i className="fa fa-usd text-white"></i>
                      <i className="fa fa-info bg-demolition"></i>
                    </div> */}
                      <img src={demolition} className="demo-img" />
                      Demolition components
                    </MDBBox>
                  </MDBBox>
                </div>
                <MDBBox className="viewer-lowertree overflow-auto">
                  {jsonDemolitionMeshesToJSX}
                  {loading ? (
                    <MDBBox className="w-100">
                      <Loading color="black" text="Loading component..." />
                    </MDBBox>
                  ) : null}
                </MDBBox>
              </MDBBox>
            </ResizablePanels>
          </div>
          {/* Mashes container ends */}

          {/* project files container starts */}
          <div style={{ height: "100%" }}>
            <ResizablePanels
              displayDirection="column"
              width="100%"
              maxheight="100%"
              panelsSize={0}
              resizerSize="3px"
              // resizerColor="#f2f2f2"
              sizeUnitMeasure="%"
            >
              <MDBBox className="overflow-auto h-86vh inner_resizable">
                {jsonFilesMeshesToJSX}
                {loading ? (
                  <MDBBox className="h-100">
                    <Loading color="black" text="Loading..." />
                  </MDBBox>
                ) : null}
              </MDBBox>
              <MDBBox></MDBBox>
            </ResizablePanels>
          </div>

          {/* 3d modal and share container starts */}
          <div className="h-100 position-relative">
            <ResizablePanels
              displayDirection="column"
              width="100%"
              height="100%"
              panelsSize={[0, 100]}
              resizerSize={menu ? "10px" : "0px"}
              resizerColor="#E6EAF4"
              sizeUnitMeasure="%"
              ref={resizeRef}
            >
              <QuantityContext.Provider
                value={{
                  Currency: currencysymb,
                  meshQuantityInfoRef: meshQuantityInfoRef.current,
                }}
              >
                <Share
                  timeline={neededTimeline}
                  rule={line?.rule}
                  pending={pending}
                  setPending={setPending}
                  withShare={withShare}
                  setWith={setWith}
                  viewerRef={viewerRef}
                  menu={menu}
                  setMenu={setMenu}
                  setPriceView={handleChangeViewPrice}
                  FiltersData={FiltersArr}
                  setTreeData={setTreeData}
                  treeData={treeData}
                  WebGL={WebGL}
                  treeFilesData={treeFilesData}
                />
              </QuantityContext.Provider>

              <div
                id="WebglViewer"
                style={{ flexGrow: 1 }}
                className="h-100 position-relative"
                ref={viewerRef}
              >
              {modelError ? (
                /* THE PAGE SAYS WHY. An empty canvas with no explanation is
                   the silent-degradation shape: the person cannot tell a
                   missing file from a broken viewer, and reports the wrong
                   bug. Each fault gets its OWN sentence - the storage error
                   body and the absent file are different problems and only
                   one of them means "re-export". */
                <div style={{
                  position: "absolute", left: 16, right: 16, top: 16, zIndex: 20,
                  background: "rgba(24,24,24,.92)", color: "#fff", borderRadius: 6,
                  padding: "12px 14px", fontSize: 13, lineHeight: 1.45,
                  border: "1px solid rgba(255,255,255,.18)",
                }}>
                  <div style={{ fontWeight: 700, marginBottom: 4 }}>
                    {modelErrorText(modelError).title}
                  </div>
                  <div style={{ opacity: .85 }}>
                    {modelErrorText(modelError).detail}
                  </div>
                </div>
              ) : null}
                {isPopover ? (
                  <MDBBox
                    className="position-absolute viewer-popover border border-dark"
                    style={popoverCoords}
                  >
                    {hoverMeshInfo()}
                  </MDBBox>
                ) : null}
                {loading ? (
                  <MDBBox className="h-100 w-100 flex-center flex-column">
                    <Loading color="black" text="Loading model..." />
                    {percentsLoaded ? (
                      <span>{percentsLoaded}% has loaded...</span>
                    ) : null}
                  </MDBBox>
                ) : null}
                {/* TOP RIGHT, the same corner as every other page (owner,
                    2026-09-20). It was mounted INSIDE the .viewer-zoom
                    group below - which is `bottom: 56px` with no left or
                    right - so it inherited that group's bottom-left corner
                    and sat interleaved with the page's own buttons. Its
                    own absolutely-positioned box makes the corner a
                    property of the STRIP rather than of whatever it was
                    dropped into. #WebglViewer is position-relative, which
                    is what these offsets are measured from. */}
                <div
                  className="position-absolute"
                  style={{ top: 12, right: 12, zIndex: 5 }}
                >
                  <ViewerViewButtons
                    viewer={() => WebGL.current && WebGL.current.viewer}
                    variant="mdb"
                  />
                </div>
                {/* THE shared toolbar (components/Viewer/ViewerToolbar) - the model
                    view's own icons and placement, on every 3D page (owner,
                    2026-09-23). This page used to hand-write the same ten
                    buttons and the same four ids. The buttons below are the
                    ones that really are this page's. */}
                <ViewerToolbar viewer={() => WebGL.current && WebGL.current.viewer}>
                <MDBBtn
                    id="enableDisableElementsBtn"
                    title="Enable/Disable Elements — toggle visibility of components in the Disabled tree"
                    size="sm"
                    color=""
                    className="bg-white modal3d-tool-btn"
                    onClick={(e) => {
                      // TimelineViewer drives the disabled-shown override
                      // locally via enumerateDisabledUids — no C# round-trip.
                      const willShow = !e.currentTarget.classList.contains('buttonEnabled');
                      e.currentTarget.classList.toggle('buttonEnabled');
                      try {
                        const store = WebGL.current?.viewer?.streaming?.state;
                        const enumerator = WebGL.current?.viewer?.streaming?.enumerateDisabledUids;
                        if (store && enumerator) {
                          const uids = enumerator();
                          uids.forEach(uid => {
                            if (willShow) store.showDisabled(uid);
                            else store.hideDisabled(uid);
                          });
                        }
                      } catch (err) {
                        console.warn('[EnableDisable] apply failed:', err);
                      }
                    }}
                  >
                    <MDBIcon icon="power-off" className="font-size-1" />
                  </MDBBtn>
                  <MDBBtn
                    id="outlierBboxesToggleBtn"
                    title="Toggle tile bounding-box wireframe overlay (debug)"
                    size="sm"
                    color=""
                    className="bg-white modal3d-tool-btn"
                    onClick={(e) => {
                      // Streaming may not be active (legacy projects) — guard the call.
                      WebGL.current.viewer.streaming.toggleShowOutlierBboxes();
                      e.currentTarget.classList.toggle('buttonEnabled');
                    }}
                  >
                    <MDBIcon icon="border-style" className="font-size-1" />
                  </MDBBtn>
                </ViewerToolbar>
              </div>
            </ResizablePanels>
          </div>
        </ResizableViewer>

        <NoMeshModal isOpen={modal} reason={noMeshReason} toggle={() => { setModal((s) => !s); setNoMeshReason(""); }} />
      </MDBBox>
    </div>
  );
};

export default TimelineViewer;